// extracted by mini-css-extract-plugin
module.exports = {"themeName":"light"};